import React, { useState, useEffect, useCallback } from "react";
import "../page/productUnit.css";

import ModalDeleteConfirmation from "../../../components/modal/modalDeleteConfirmation";
import ProductUnitHeader from "../component/productUnitHeader";
import ProductUnitTable from "../component/productUnitTable";
import ModalAddProductUnit from "../component/modalAddProductUnit";
import { Constant } from "../../../helper/constant";
import { useNavigate } from "react-router-dom";

const ProductUnit = () => {
  // =====================
  // Constant Definition
  // =====================
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isOpenModalAddProductUnit, setIsOpenModalAddProductUnit] =
    useState(false);
  const [selectedProductUnitData, setSelectedProductUnitData] = useState({
    product_unit_id: "",
    product_unit_name: "",
  });
  const [page, setPage] = useState(0);

  const [listProductUnitData, setListProductUnitData] = useState(null);
  const [isOpenModalDeleteProductUnit, setIsOpenModalDeleteProductUnit] =
    useState(false);
  const [idProductUnitToDelete, setIdProductUnitToDelete] = useState("");

  // =====================
  // Function Definition
  // =====================

  const addNewProductUnit = () => {
    resetSelectedProductUnitDataValue();
    setIsOpenModalAddProductUnit(true);
  };

  const onEditProductUnit = (productUnitData) => {
    setSelectedProductUnitData(productUnitData);
    setIsOpenModalAddProductUnit(true);
  };

  const onDeleteProductUnit = (productUnitData) => {
    setIsOpenModalDeleteProductUnit(true);
    setIdProductUnitToDelete(productUnitData.product_unit_id);
  };

  const onDeleteProductUnitConfirmed = () => {
    setIsOpenModalDeleteProductUnit(false);
    deleteProductUnit();
  };

  const onCloseModalDeleteProductUnit = () => {
    setIdProductUnitToDelete("");
    setIsOpenModalDeleteProductUnit(false);
  };

  const onCloseModal = () => {
    resetSelectedProductUnitDataValue();
    setIsOpenModalAddProductUnit(false);
  };

  const onSubmitNewProductUnit = (productUnitData, isEditData) => {
    setIsOpenModalAddProductUnit(false);
    if (isEditData) {
      editProductUnit(productUnitData);
    } else {
      createNewProductUnit(productUnitData);
    }
  };

  const resetSelectedProductUnitDataValue = () => {
    setSelectedProductUnitData({
      product_unit_id: "",
      product_unit_name: "",
    });
  };

  // =====================
  // Request Method
  // =====================

  const getProductUnitData = useCallback(async () => {
    try {
      setIsLoading(true);
      localStorage.setItem("searchValue", "");
      const response = await fetch(Constant.BASE_API_URL + "/unit-produk", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "bearer " + localStorage.getItem("token"),
        },
      });
      if (!response.ok) {
        alert("Gagal Menerima Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }
      const json = await response.json();
      const data = json.data;
      const productUnit = data.product_unit;
      if (!productUnit) {
        setListProductUnitData([]);
      }
      setListProductUnitData(productUnit);
    } catch (error) {
      setListProductUnitData([]);
    } finally {
      setIsLoading(false);
    }
  }, [navigate]);

  const createNewProductUnit = async (productUnitData) => {
    try {
      setIsLoading(true);
      const response = await fetch(Constant.BASE_API_URL + "/unit-produk", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify({
          product_unit_name: productUnitData.product_unit_name,
        }),
      });
      if (!response.ok) {
        alert("Terdapat Kesalahan Dalam Memproses Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }
    } finally {
      getProductUnitData();
    }
  };

  const editProductUnit = async (productUnitData) => {
    try {
      setIsLoading(true);
      const productUnitId = productUnitData.product_unit_id;
      const response = await fetch(
        Constant.BASE_API_URL + "/unit-produk/" + productUnitId,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer " + localStorage.getItem("token"),
          },
          body: JSON.stringify({
            product_unit_name: productUnitData.product_unit_name,
          }),
        }
      );
      if (!response.ok) {
        alert("Gagal Mengubah Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }
    } finally {
      getProductUnitData();
    }
  };

  const deleteProductUnit = async () => {
    try {
      setIsLoading(true);
      const productUnitId = idProductUnitToDelete;
      const response = await fetch(
        Constant.BASE_API_URL + "/unit-produk/" + productUnitId,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (!response.ok) {
        alert("Gagal Menghapus Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }
    } finally {
      setIdProductUnitToDelete("");
      getProductUnitData();
    }
  };

  const searchProductUnit = (searchText) => {
    if (searchText.length > 3) {
      getProductUnitSearchData(searchText, false, false, "", "");
    } else if (searchText.length === 0) {
      getProductUnitData();
    }
  };

  const getProductUnitSearchData = useCallback(
    async (keyword, isNextPage, isPreviousPage, nextCursor, prevCursor) => {
      try {
        setIsLoading(true);

        let state = "";
        let cursorId = "";

        if (isNextPage) {
          state = "next_page";
          cursorId = nextCursor;
        } else if (isPreviousPage) {
          state = "previous_page";
          cursorId = prevCursor;
        }

        let url = new URL(Constant.BASE_API_URL + "/unit-produk/search");
        url.searchParams.append("keyword", keyword);
        if (state !== "") {
          url.searchParams.append("cursor", cursorId);
          url.searchParams.append("state", state);
        } else {
          setPage(0);
        }

        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer " + localStorage.getItem("token"),
          },
        });
        if (!response.ok) {
          alert("Gagal Menerima Data");
          if (response.status === 401 || response.status === 403) {
            localStorage.clear();
            return navigate("/login", { replace: true });
          }
        }
        const json = await response.json();
        const data = json.data;
        const productUnit = data.product_unit;
        if (!productUnit) {
          setListProductUnitData(null);
        } else {
          setListProductUnitData(productUnit);
        }
      } catch (error) {
        setListProductUnitData(null);
      } finally {
        setIsLoading(false);
      }
    },
    [navigate]
  );

  // =====================
  // Use Effect Method
  // =====================

  useEffect(() => {
    getProductUnitData();
  }, [getProductUnitData]);

  // =====================
  // Render Method
  // =====================

  return isLoading ? (
    <div className="loading-container">
      <div className="loader"></div>
      <p>Sedang Memuat Mohon Menunggu</p>
    </div>
  ) : (
    <div>
      <h1>Produk Unit</h1>
      <ProductUnitHeader
        onAddProductUnitClicked={addNewProductUnit}
        onSearchProductUnitEdited={searchProductUnit}
      />
      <ProductUnitTable
        productUnit={listProductUnitData}
        onEditProductUnitClicked={onEditProductUnit}
        onDeleteProductUnitClicked={onDeleteProductUnit}
      />
      <ModalAddProductUnit
        isShowModal={isOpenModalAddProductUnit}
        onCloseModal={onCloseModal}
        onSubmitData={onSubmitNewProductUnit}
        productUnitObject={selectedProductUnitData}
        key={Date.now()}
      />
      <ModalDeleteConfirmation
        isShowModal={isOpenModalDeleteProductUnit}
        onCloseModal={onCloseModalDeleteProductUnit}
        onDeleteConfirmed={onDeleteProductUnitConfirmed}
        idToDelete={idProductUnitToDelete}
      />
    </div>
  );
};

export default ProductUnit;
